import { Link } from "react-scroll";

/*--------------------
* CTA Band
----------------------*/
export default function Intrested() {
  return (
    <section className="relative py-16 md:py-20 bg-night-700 overflow-hidden">
      <div
        className="absolute inset-0 pointer-events-none"
        aria-hidden="true"
        style={{
          background:
            "radial-gradient(ellipse 50% 120% at 80% 100%, rgba(255,140,66,0.18) 0%, transparent 70%)",
        }}
      ></div>
      <div className="container relative z-[1]">
        <div className="flex flex-col md:flex-row items-center justify-between gap-8 text-center md:text-left">
          <div>
            <p className="eyebrow mb-3">Open invitation</p>
            <h4 className="text-[26px] md:text-[34px] font-[600] leading-[1.2] m-0">
              Got an idea that keeps <em className="not-italic gradient-text">you</em> up
              at night?
            </h4>
          </div>
          <Link className="btn btn-ember shrink-0" smooth={true} to="contact">
            Let's talk
          </Link>
        </div>
      </div>
    </section>
  );
}
